import { gql } from "@apollo/client";

export const DELETE_AJUSTE_LIQUIDACION = gql`
    mutation deleteAjusteLiquidacion($idLiquidacionProfesionalDetalle: Int!) {
        deleteAjusteLiquidacion(idLiquidacionProfesionalDetalle: $idLiquidacionProfesionalDetalle)
    }
`;